/** Retention belongs to work completed on the row, independent of contract size. */
export function retentionTotals(project, completedAmount) {
  const executed = Number(completedAmount) || 0;
  const percentage = Number(project?.remaining_amount_percentage ?? 10);
  const retention = project?.remaining_amount_enabled
    ? Math.round((executed * percentage + Number.EPSILON) ) / 100
    : 0;
  return {
    executed,
    retention,
    invoiceAmount: Math.round(Math.max(0, executed - retention) * 100) / 100,
  };
}
